module.exports = __webpack_public_path__ + "dingbeauty-build/img/service2@2.d70169c4.jpg";